import { createFormAction } from 'redux-form-saga'
export const QUICK_FORM_KEY = 'QUICK_FORM'
export const QuickFormAction = createFormAction(QUICK_FORM_KEY)
